import { capitalize, deburr } from 'lodash'

export const clearText = (str: string) => {
  return deburr(str
    .replace(/[~!@#$%\\^&/*|,.=`()№_+}\-{'":;>?<[\]]|[\d]/g, '')
    .replace(/[\s]{2,}/g, ' '),
  ).split(' ').map(capitalize).join(' ') as string
}
